import Splide from '@splidejs/splide'

class Home {
  constructor(el) {
    this.DOM = {
      el,
      banner: el.querySelector('.js-banner'),
    }
  }

  init() {
    this.bannerInit()
  }

  bannerInit() {
    const activeSlide = this.DOM.banner.querySelector('.js-banner-active')
    const splide = new Splide(this.DOM.banner, {
      type: 'fade',
      pagination: false,
      rewind: false,
      clones: 0,
    })

    splide.on('moved', (newIndex) => {
      activeSlide.innerHTML = newIndex + 1
    })

    splide.on('active', (e) => {
      const videoData = e.slide.querySelector('.js-banner-video')
      if (videoData) {
        const videoButton = e.slide.querySelector('.js-banner-video-pause')
        const video = videoData.querySelector('.js-banner-video-src')
        video.play()
        videoButton.classList.remove('active')
      }
    })

    splide.on('inactive', (e) => {
      const videoData = e.slide.querySelector('.js-banner-video')
      if (videoData) {
        const video = videoData.querySelector('.js-banner-video-src')
        video.pause()
      }
    })

    splide.mount()

    const bannerVideos = this.DOM.banner.querySelectorAll('.js-banner-video')
    bannerVideos.forEach((el) => {
      const videoButton = el.querySelector('.js-banner-video-pause')
      const video = el.querySelector('.js-banner-video-src')
      videoButton.addEventListener('click', () => {
        if (video.paused) {
          video.play()
          videoButton.classList.remove('active')
        } else {
          video.pause()
          videoButton.classList.add('active')
        }
      })
    })
  }
}

export default Home
